import React, { ReactElement } from "react";
import Styles from "../dashboard.module.scss";

type WarningProps = {
  children: ReactElement<"p">; // Enforces that children must be a <p> element
};

function WarningBar({ children }: WarningProps) {
  return (
    <div className={`${Styles.warningBar}`}>
      <span className={`${Styles.gridItem}`}>
        <b className="fw-bold">Alert:</b>
        {children}
      </span>
    </div>
  );
}

export default WarningBar;
